import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

const PerformanceGaugeGraph = ({ graphSetting, divId, tsize, height }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    
    am4core.useTheme(am4themes_animated);
    let chart = am4core.create(divId ? divId : "DivID", am4charts.GaugeChart);
    // if (labelText) {

    // gauge chart settings
    chart.innerRadius = "80%";
    // chart.marginTop = -100;
    chart.paddingBottom = -80;
    chart.paddingLeft = -20;
    chart.paddingTop = -60;
    chart.paddingRight = -20;
    chart.height = am4core.percent(80);

    if (graphSetting.numbeOfGraph > 5) {
      chart["paddingBottom"] = -35;
      chart["paddingTop"] = -25;
      chart["paddingLeft"] = -10;
      chart["paddingRight"] = -10;
    }

    // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";

    // Normal axis
    let axis = chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.renderer.grid.template.disabled = true;
    axis.renderer.grid.template.strokeOpacity = 0.3;
    axis.renderer.labels.template.disabled = true;

    // Range
    var range0 = axis.axisRanges.create();
    range0.value = graphSetting.graphColor.g.startAngle;
    range0.endValue = graphSetting.graphColor.g.endAngle;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = am4core.color("#20bf6b");

    var range1 = axis.axisRanges.create();
    range1.value = graphSetting.graphColor.o.startAngle;
    range1.endValue = graphSetting.graphColor.o.endAngle;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color("#f7b731");

    var range2 = axis.axisRanges.create();
    range2.value = graphSetting.graphColor.r.startAngle;
    range2.endValue = graphSetting.graphColor.r.endAngle;
    range2.axisFill.fillOpacity = 1;
    range2.axisFill.fill = am4core.color("#dc3545");

    // Main label
    var label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = graphSetting.value_style.fontSize.indexOf("px")
      ? graphSetting.value_style.fontSize.substr(
          0,
          graphSetting.value_style.fontSize.indexOf("px")
        )
      : graphSetting.value_style.fontSize;
    label.x = am4core.percent(70);
    label.y = am4core.percent(60);
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    label.text = graphSetting.value ? graphSetting.value + "%" : "0%";
    label.fill = graphSetting.value_style.color;
    label.fontSize = tsize ? tsize : "15px";

    // Hand
    var hand = chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis;
    // hand.innerRadius = graphSetting.numbeOfGraph > 5 ? 5 : 30;
    // hand.startWidth = graphSetting.numbeOfGraph > 5 ? 5 : 10;
    hand.innerRadius = am4core.percent(50);
    hand.radius = am4core.percent(80);
    hand.width = "`15px";
    hand.pin.disabled = true;
    hand.value = graphSetting.value ? parseInt(graphSetting.value) : 0;
    // hand.fill = am4core.color("#b1b0b5");
    // hand.stroke = am4core.color("#b1b0b5");
    hand.fill = am4core.color("lightgrey");
    hand.stroke = am4core.color("lightgrey");

    chartRef.current = chart;
    // }

    return () => {
      chart.dispose();
    };
  }, [graphSetting.value]);

  useEffect(() => {}, [graphSetting]);
  // console.log("_________________________________________________________________________")
  // console.log(graphSetting)
  var config = {
    percent: 50.75,
    radius: 0.8,
    range: {
      ticks: [0, 1 / 3, 2 / 3, 1],
      color: ["#F4664A", "#FAAD14", "#30BF78"],
    },
    indicator: {
      pointer: { style: { stroke: "#D0D0D0" } },
      pin: { style: { stroke: "#D0D0D0" } },
    },
    statistic: {
      content: {
        style: {
          fontSize: "10px",
          lineHeight: "5px",
        },
      },
    },
    // label: null,
  };

  return (
    <div>
      {/* <Gauge {...config} height={200} /> */}
      <div
        id={divId ? divId : "DivID"}
        style={{ width: "100%", height: height }}
      ></div>
    </div>
  );
};

const propsChange = (prev, next) => {
  return prev !== next;
};

export default PerformanceGaugeGraph;
